import { render, staticRenderFns } from "./FileSizeInfo.vue?vue&type=template&id=4f2c142e"
import script from "./FileSizeInfo.vue?vue&type=script&lang=ts"
export * from "./FileSizeInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports